<template>
  <div id="component-container">
    <div class="content-pagination" v-if="show_table">
      <!--<span v-if="!show.loading" class="rows-count">{{countMessage}}</span>-->
      <!--<b-pagination :total-rows="tableData.length" @change="changePage" align="center" :per-page="limit"-->
      <!--:current-page="page" v-model="page"-->
      <!--v-if="tableData.length > 0">-->
      <!--</b-pagination>-->
      <b-form-group label-cols-sm="2" :label="this.$t('table.filter')" class="table-filter">
        <b-input-group>
          <b-form-input v-model="filter" :placeholder="this.$t('table.filter_placeholder')"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">⟲</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-pagination class="table-pagination" :total-rows="totalRows" @change="changePage" align="fill" :per-page="limit"
                    :current-page="page" v-model="page"
                    v-if="totalRows > 0">
      </b-pagination>
    </div>
    <b-spinner v-if="!show && !show_table" class="spinner-center"/>
    <div v-if="empty" class="center">
      <p>{{$t('no_data')}}</p>
    </div>
    <div class="content-graph" ref="chartContainer">
      <bar-chart v-if="show && !empty" :height="chartHeight" style="padding: 30px" id="data-chart-a" :chart-data="chart[0]" :options="options"></bar-chart>
    </div>
    <div class="content-list">
      <b-table v-if="show_table" small striped hover fixed :items="tableData"  :fields="fields" :current-page="page" :per-page="limit" sort-by="coef" sort-desc :filter="filter"  @filtered="onFiltered"></b-table>
    </div>
  </div>
</template>

<script>
  import BarChart from '../components/BarChart'
  import axios from 'axios'

  export default {
    name: 'LemmaDif',
    props: {
      taskId: {
        type: String
      }
    },
    components: {BarChart, axios},
    data () {
      return {
        tableData: [],
        chartData: [],
        chartHeight: 400,
        totalRows: 1,
        limit: 50,
        page: 1,
        skip: 50,
        filter: null,
        show: false,
        empty: false,
        show_table: false,
        chart: [
          {
            labels: [],
            datasets: [
              {
                backgroundColor: ['#f44336', '#2196f3', '#ffc107', '#4caf50', '#7e57c2', '#8d6e63', '#ec407a', '#3f51b5', '#7cb342', '#c7c7c7'],
                data: []
              }
            ]
          }
        ],
        corpora_name: ['a', 'b']
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.getLabels()
      axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/lemma_dif')
              .then((response) => {
                if (response.data.error === 'corpus not processed') {
                  this.$router.push({path: '/'})
                } else {
                  if (Object.keys(response.data).length > 0) {
                    this.mapTableData(response.data)
                    this.resizeChart()
                  } else {
                    this.empty = true
                  }
                  this.show = true
                }
              }).catch(function (error) {
                // handle error
                alert(error)
              })
              .finally(function () {
                // always executed
              })
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'lemma',
            label: this.$t('table.lemma.lemma'),
            sortable: true
          },
          {
            key: 'count_a',
            label: this.$t('table.lemma.count') + '"' + this.corpora_name[0] + '"',
            sortable: true
          },
          {
            key: 'count_b',
            label: this.$t('table.lemma.count') + '"' + this.corpora_name[1] + '"',
            sortable: true
          },
          {
            key: 'freq_a',
            label: this.$t('table.lemma.freq') + '"' + this.corpora_name[0] + '"',
            sortable: true
          },
          {
            key: 'freq_b',
            label: this.$t('table.lemma.freq') + '"' + this.corpora_name[1] + '"',
            sortable: true
          },
          {
            key: 'coef',
            label: this.$t('table.lemma.coef'),
            sortable: true,
            sortDirection: 'desc'
          }
        ]
      },
      options: function () {
        return {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: this.$t('charts.lemma_dif.title')
          },
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: 'percentage',
            precision: 1
          }
        }
      }
    },
    watch: {
      page: function (value) {
        this.page = value
        this.skip = this.limit * this.page
      },
      limit: function (value) {
        this.limit = value
        if (this.page > parseInt(this.table.data.length / this.limit) + 1) {
          this.page = parseInt(this.table.data.length / this.limit) + 1
        }
        this.skip = this.limit * this.page
      },
      options: function () {
        this.show = false
        setTimeout(() => {
          this.show = true
        }, 0)
      }
    },
    methods: {
      getLabels: function () {
        axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/base')
                .then((response) => {
                  if (response.data.error === 'corpus not processed') {
                    console.log(response.data.error)
                    this.$router.push({path: '/'})
                  } else {
                    this.corpora_name[0] = response.data.a.name
                    this.corpora_name[1] = response.data.b.name
                    this.fields[1].label = this.$t('table.lemma.count') + '"' + this.corpora_name[0] + '"'
                    this.fields[2].label = this.$t('table.lemma.count') + '"' + this.corpora_name[1] + '"'
                    this.fields[3].label = this.$t('table.lemma.freq') + '"' + this.corpora_name[0] + '" [%]'
                    this.fields[4].label = this.$t('table.lemma.freq') + '"' + this.corpora_name[1] + '" [%]'
                  }
                }).catch(function (error) {
                  // handle error
                  alert(error)
                })
                .finally(function () {
                  // always executed
                })
      },
      changePage: function (value) {
        try {
          this.page = value
        } catch (e) {
          console.log(Object.keys(e), e.message)
        }
      },
      changeLimit: function (value) {
        try {
          this.limit = value
        } catch (e) {
          console.log(Object.keys(e), e.message)
        }
      },
      mapTableData (data) {
        for (var item in data) {
          this.tableData.push({
            'lemma': item,
            'coef': this.roundNumber(data[item].coef, '2'),
            'count_a': data[item].count_a,
            'count_b': data[item].count_b,
            'freq_a': this.roundNumber(data[item].freq_a * 100, '4'),
            'freq_b': this.roundNumber(data[item].freq_b * 100, '4')
          })
          this.show_table = true
          this.chartData.push({
            'lemma': item,
            'coef': this.roundNumber(data[item].coef, '2'),
            'count_a': data[item].count_a,
            'count_b': data[item].count_b,
            'freq_a': this.roundNumber(data[item].freq_a, '4'),
            'freq_b': this.roundNumber(data[item].freq_b, '4')
          })
        }
        this.totalRows = this.tableData.length
        this.mapChartData(this.chartData)
      },
      mapChartData: function (data) {
        data.sort(this.compareBy('coef'))
        for (let i = 0; i < 10; i++) {
          this.chart[0].labels[i] = '"' + data[i].lemma + '"'
          this.chart[0].datasets[0].data[i] = data[i].coef
        }
        // let others = 0
        // for (let i = 10; i < data.length; i++) {
        //   others += data[i].coef
        // }
        // this.chart[0].labels[9] = '*'
        // this.chart[0].datasets[0].data[9] = this.roundNumber(others, '2')
        console.log(this.chart[0])
      },
      roundNumber: function (num, scale) {
        // console.log(num, scale)
        return +(Math.round(num + 'e+' + scale) + 'e-' + scale)
      },
      compareBy: function (key) {
        return function (a, b) {
          // Use toUpperCase() to ignore character casing
          const varA = a[key]
          const varB = b[key]

          let comparison = 0
          if (varA < varB) {
            comparison = 1
          } else if (varA > varB) {
            comparison = -1
          }
          return comparison
        }
      },
      resizeChart: function () {
        if (window.innerWidth > 768) {
          this.chartHeight = Math.ceil(this.$refs.chartContainer.clientHeight - 60)
        } else {
          this.chartHeight = Math.ceil(this.$refs.chartContainer.clientHeight - 60)
        }
      },
      redrawChart: function () {
        this.show = false
        this.resizeChart()
        setTimeout(() => {
          this.show = true
        }, 0)
      },
      handleResize (event) {
        this.redrawChart()
      },
      onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.page = 1
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div.center {
    height: 10em;
    position: relative }
  div.center p {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%) }
  .content-pagination {
    width: 100%;
    height:120px;
    padding: 6px;
    /*display:inline-block;*/
  }
  .content-list {
    height: 100%;
    width: 100%;
    /*overflow: initial;*/
    /*margin-top: -50px;*/
  }
  .content-graph {
    background-color: var(--white_layer);
    height: 100%;
    width: 100%;
    /*overflow: initial;*/
  }
  .table-pagination {
    width: 100%;
    margin: 6px;
    float: inherit;
  }
  .table-filter {
    width: 100%;
    margin: 6px;
    float: inherit;
  }
  @media only screen and (min-width: 768px) {
    .content-pagination {
      height: 60px;
      width: 59%;
      margin:0 0 0 40%;
      padding-right: 10px;
    }
    .content-list {
      height: calc(100% - 60px);
      width: 59%;
      overflow: auto;
      display:inline-block;
    }
    .content-graph {
      height: calc(100% - 60px);
      width: 40%;
      overflow: auto;
      display:inline-block;
    }
    .table-pagination {
      width: 60%;
      margin: 6px 0 10px 0;
      float: left;
    }
    .table-filter {
      width: 40%;
      margin: 6px 0 10px 0;
      float: left;
      padding-right: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/LemmaDif.vue